import { Box } from '@mui/material';
import { FunctionComponent } from 'react';
import { L3ServiceStatus, serviceStatusColorMap } from '../../../l3-services/model';

interface Props {
  status: L3ServiceStatus;
}

export const TopologyL3ServiceStatusPoint: FunctionComponent<Props> = ({ status }) => {
  return <Box sx={{ width: 10, height: 10, mr: 1, borderRadius: '50%', backgroundColor: serviceStatusColorMap[status] }} />;
};